import ja from './ja';
import en from './en';

export type TranslationKey = keyof typeof ja;

/** All supported locale translation maps. */
const translations: Record<'ja' | 'en', Record<TranslationKey, string>> = { ja, en };

/**
 * t — returns the Japanese translation for the given key.
 * English translations are loaded but language switching is not yet implemented.
 * TODO: Add locale detection and switching (e.g. PCG-XXXX).
 */
export function t(key: TranslationKey, params?: Record<string, string>): string {
  const locale = translations['ja'];
  let value = locale[key];
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      // A replacer function inserts `v` literally. Passing it as a string would
      // let `$&`, `$1`, `` $` `` etc. inside server-supplied values (e.g. a
      // filtering condition name) be interpreted as replacement patterns and
      // corrupt the message.
      value = value.replace(new RegExp(`\\{${k}\\}`, 'g'), () => v);
    }
  }
  return value;
}
